import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { CoreModule } from '@core/core.module';
import { WanHealthComponent } from '@app/features/wan/modules/wan-health/wan-health.component';
import { DeviceModule } from '@app/features/device-health/device.module';
import { HealthNavComponent } from '@app/shared/components/health-nav/health-nav.component';

@NgModule({
    imports: [
        CommonModule,
        CoreModule,
        SharedModule,
        DeviceModule,
        HealthNavComponent
    ],
    declarations: [
        WanHealthComponent
    ],
    providers: [],
    exports: [],
    bootstrap: []
})
export class WanModule {}